import type { MarketConfiguration } from "./const";
import {
  ContentfulEnum,
  CurrencyEnum,
  ElevateMarketEnum,
  LocaleEnum,
  MarketEnum,
  RegionEnum,
  ServiceLocaleEnum,
} from "./const";

const romania: MarketConfiguration = {
  code: MarketEnum.ro,
  label: "Romania",
  descriptiveLabel: "Romanian",
  contentfulLocale: ContentfulEnum.en,
  contentfulCountry: "Romania",
  locale: LocaleEnum.ro,
  serviceLocale: ServiceLocaleEnum.ro,
  language: {
    code: "en",
    label: "English",
    flag: "gb",
  },
  currency: CurrencyEnum.eur,
  link: "https://www.no-ga.com/en-ro",
  termsSlug: "terms-online",
  loop54Market: MarketEnum.ro,
  adyenMarket: MarketEnum.ro,
  elevateMarket: ElevateMarketEnum.eu,
  freeShippingEnabled: false,
  freeShippingThreshold: 100,
  externalStoreId: "ecom-noga",
  searchPathName: "search",
  adyenCheckoutEnabled: true,
  walleyCheckoutEnabled: false,
  hasTrustPilot: false,
  region: RegionEnum.europe,
  norceImageCdn: ["local", "dev", "stage"].includes(
    process.env.NEXT_PUBLIC_ENVIRONMENT ?? "",
  )
    ? "https://media.stage.cdn-norce.tech/1413"
    : "https://cdn.no-ga.com",
};

export default romania;
